module.exports = __webpack_public_path__ + "img/tools_paytrend1_1.dcf745f6.png";